var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from "react";
import { MdExpandMore } from "react-icons/md";
import { styled } from "../styling";
import { AccordionContext } from "./Accordion";
import { AccordionItemContext } from "./AccordionItem";
import { ControlButton } from "../ControlButton";
const StyledDiv = styled.div `
  display: flex;
  cursor: pointer;
  padding: 0.5em;
  &:hover {
    background-color: ${(props) => props.theme.colors.action.hover};
  }
  justify-content: space-between;
`;
const StyledControlButton = styled(ControlButton) `
  transform: rotate(${(props) => (props.active ? "180deg" : "0deg")});
  transition: transform 0.3s ease-out;
`;
export const AccordionItemHeading = (props) => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    const index = useContext(AccordionItemContext);
    const { activeIndex, setActiveIndex } = useContext(AccordionContext);
    return (React.createElement(StyledDiv, Object.assign({}, rest, { className: className, role: "button", onClick: () => setActiveIndex(index !== activeIndex ? index : undefined) }),
        children,
        React.createElement(StyledControlButton, { active: index === activeIndex },
            React.createElement(MdExpandMore, null))));
};
//# sourceMappingURL=AccordionItemHeading.js.map